// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'dataviz-pie';

export const Component = () => (
  <path d='m12.298 14.357 7.998 8.238c2.156-2.347 3.257-5.125 3.257-8.334 0-3.209-1.101-6.034-3.257-8.381C18.141 3.533 15.46 2.24 12.298 2v12.357ZM11.29 4.923v8.812H2c.144-2.442 1.102-4.55 2.873-6.274 1.772-1.677 3.928-2.538 6.418-2.538Zm0 9.818 6.226 6.418c-1.772 1.58-3.831 2.394-6.226 2.394-2.49 0-4.645-.862-6.418-2.586-1.771-1.676-2.73-3.783-2.873-6.226h9.291Z' />
);

export const viewBox = '0 0 25 25';
